import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { APP_PROMO_BANNER } from '@constants/trim-tool';
import IVButton from '@invideoio/uniformd/components/Button';
import { OSType, PlatformType } from '@invideoio/web-shared/constants/common';
import GlobalConfig from '@invideoio/web-shared/lib/GlobalConfig';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { SessionStorage, SessionStorageType } from '@utils/sessionStorage';
import { useEffect, useState } from 'react';
import { AppPromoBannerProps, AppPromoBannerType } from './types';

const AppPromoBanner = (props: AppPromoBannerProps) => {
  const { os, platform } = props;
  const {
    buttonLabel,
    crossIcon,
    gradientClass,
    heading,
    icon,
    iconText,
    subHeading,
  }: AppPromoBannerType = APP_PROMO_BANNER;
  const { url } = GlobalConfig.APP_PROMO_LINKS.mobile.Android;

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    let showMobileAppBanner = SessionStorage.getItem(
      SessionStorageType.mobileHeaderAppPromo,
    );
    if (showMobileAppBanner === null) {
      SessionStorage.setItem(SessionStorageType.mobileHeaderAppPromo, true);
      showMobileAppBanner = 'true';
    }
    setShowBanner(
      showMobileAppBanner === 'true' && platform !== PlatformType.Desktop,
    );
  }, []);

  const closeBanner = () => {
    setShowBanner(false);
    SessionStorage.setItem(SessionStorageType.mobileHeaderAppPromo, false);
  };

  return (
    <div
      className={ivclass(
        'iv-px-15 iv-py-20',
        'iv-bg-grey-5',
        !showBanner && 'iv-hidden',
      )}
    >
      <div className={ivclass('iv-flex', 'iv-items-center')}>
        <IVButton
          className={ivclass('iv-inline-block', 'iv-pr-15')}
          onClick={() => closeBanner()}
        >
          <ImageComponent
            elementype="native"
            src={crossIcon}
            alt="cross"
            width="10px"
            height="10px"
          />
        </IVButton>
        <div className={ivclass('iv-inline-block', 'iv-pr-15')}>
          <div
            className={ivclass(
              'iv-flex',
              'iv-justify-center',
              'iv-items-center',
              'iv-w-[62px] iv-h-[62px]',
              'iv-text-grey-0',
              'iv-text-[20px]',
              'iv-rounded-[14px]',
              'iv-font-extrabold',
              gradientClass,
            )}
          >
            {iconText}
          </div>
        </div>
        <div
          className={ivclass(
            'iv-flex',
            'sm:iv-flex-col',
            'iv-justify-between sm:iv-justify-center',
            'iv-items-center sm:iv-items-start',
            'iv-w-full',
          )}
        >
          <div className={ivclass('iv-inline-block')}>
            <div
              className={ivclass(
                'iv-text-body-xl',
                'iv-text-grey-85',
                'iv-font-bold',
              )}
            >
              {heading}
            </div>
            <div
              className={ivclass(
                'iv-pt-5',
                'iv-text-grey-40',
                'iv-text-body-l',
                'iv-font-medium',
              )}
            >
              {subHeading}
            </div>
          </div>

          <div className={ivclass('sm:iv-pt-5')}>
            <a
              href={url}
              target="_self"
              className={ivclass(
                'iv-flex',
                'iv-justify-center iv-items-center',
              )}
            >
              <span
                className={ivclass(
                  'iv-pr-5',
                  'iv-text-blue',
                  'iv-text-body-l',
                  'iv-font-medium',
                )}
              >
                {(os === OSType.iOS && buttonLabel[os]) || buttonLabel.Android}
              </span>
              <span className={ivclass('iv-relative', 'iv-inline-block')}>
                <ImageComponent
                  elementype="native"
                  src={icon.url}
                  alt={icon.alt}
                  width={icon.width}
                  height={icon.height}
                />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppPromoBanner;
